import { useState } from "react";

import toast from "react-hot-toast";

import { useUser } from "@ip-contexts/user-context";
import { MainWithSidebar } from "@ip-layout";
import { trackEvent } from "@ip-utils";
import { SecondaryButtonWithLoadingIcon } from "@ip-widgets/Tailwind/common/button";
import { Divider } from "@ip-widgets/Tailwind/common/divider";
import { H1 } from "@ip-widgets/Tailwind/common/header";
import {
  HorizontalSplit,
  TitleWithDescription,
} from "@ip-widgets/Tailwind/common/stack";
import { VNavWithIcon } from "@ip-widgets/Tailwind/common/vertical-navigation";
import { MFA } from "@ip-widgets/Tailwind/mfa";

export default function SecurityAndLogin() {
  const {
    state: { user, status },
  } = useUser();
  const { email } = user;
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChangePasswordOnClick = async () => {
    trackEvent("security", "Request reset password email");

    setLoading(true);
    toast.loading("Sending email");
    const url = `https://${process.env.REACT_APP_AUTH0_ORIGINAL_DOMAIN}/dbconnections/change_password`;

    const res = await fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
        email,
        connection: "Username-Password-Authentication",
      }),
    });

    setLoading(false);
    toast.dismiss();

    if (res.status === 200) {
      setSuccess(true);
      toast.success("Success");
    } else {
      if (res.status === 429) {
        setError(true);
        toast.error("Too many requests");
      } else if (res.status !== 200) {
        setError(true);
        toast.error("Could not send email");
      }
    }
  };

  return (
    <MainWithSidebar
      main={
        <Main
          user={user}
          status={status}
          onClick={handleChangePasswordOnClick}
          success={success}
          loading={loading}
          error={error}
        />
      }
      sidebar={<VNavWithHeaderAndIcon />}
    />
  );
}

const Main = ({ user, status, onClick, success, loading, error }: any) => {
  if (!user || status !== "resolved") {
    return <div>Loading</div>;
  }
  return (
    <div className="w-10/12">
      <div className="px-0 pt-12 mx-auto max-w-7xl md:px-12 lg:px-12">
        <HorizontalSplit
          left={
            <TitleWithDescription
              title="Change Password"
              description="We will send a password reset link to your email address"
            />
          }
          right={
            <SecondaryButtonWithLoadingIcon
              text="Request"
              onClick={onClick}
              success={success}
              loading={loading}
              error={error}
            />
          }
        />

        <Divider />

        <MFA />
      </div>
    </div>
  );
};

const VNavWithHeaderAndIcon = () => {
  return (
    <div className="flex flex-col flex-grow pt-5 pb-4 overflow-y-auto bg-white border-r border-gray-200">
      <div className="flex items-center flex-shrink-0 px-8">
        <H1 text={"Settings"} />
      </div>
      <div className="flex flex-col flex-grow mt-5">
        <VNavWithIcon currentPage="/security" />
      </div>
    </div>
  );
};
